import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  flex-direction: column;
  gap: 5px;
  grid-column: span 12;
  margin-top: 15px;
`;

export const Row = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;
`;

export const Index = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 20px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
`;

export const Inputs = styled.div`
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 15px;
`;

export const CenterdColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.div`
  width: fit-content;
  font-size: 11px;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  padding: 0 4px 0 2px;
  border-radius: 2px;
  background-color: rgba(0, 65, 132, 0.1);
  color: rgba(0, 65, 132, 1);
`;
